module.exports = __webpack_public_path__ + "img/application-submitted.c5189323.svg";